/**
 * FormulaError — ошибки парсинга, валидации и вычисления формул.
 */
export class FormulaError extends Error {
  constructor(
    message: string,
    public code:
      | 'syntax_error'
      | 'unknown_field'
      | 'circular_dependency'
      | 'type_error'
      | 'invalid_formula',
    public position?: number,
  ) {
    super(message);
    this.name = 'FormulaError';
  }
}
